export default __webpack_public_path__ + "static/locked-in-stone-3f39a35afdb5994c48c185d0cb8e80b1.jpg";